import { useState } from "react";
import { Link } from "react-router-dom";
import "./ChangePassword.css";
import BarDeretourSetting from "../../../components/BarDeretourSetting";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";

export default function ChangePasswordAdmin() {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
        <>
            <NewSideBarAdmin />
            <div className="container mt-5 settings-container">
                <BarDeretourSetting />
                <div className="card-form-wrapper">
                    <div className="card-form-header">
                        <div className="icon-wrapper">
                            <i className="bi bi-shield-lock"></i>
                        </div>
                        <h5>Changer le mot de passe</h5>
                        <p className="card-form-subtitle">Assurez-vous de choisir un mot de passe fort et sécurisé.</p>
                    </div>

                    <form className="card-form-body" onSubmit={(e) => e.preventDefault()}>
                        <div className="form-group mb-3">
                            <label className="form-label">Ancien mot de passe</label>
                            <div className="input-icon-group">
                                <i className="bi bi-key input-icon"></i>
                                <input 
                                    type={showOldPassword ? "text" : "password"} 
                                    className="form-control custom-input" 
                                    placeholder="••••••••" 
                                />
                                <i 
                                    className={`bi ${showOldPassword ? "bi-eye" : "bi-eye-slash"} toggle-eye-icon`} 
                                    onClick={() => setShowOldPassword(!showOldPassword)}
                                    title={showOldPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                ></i>
                            </div>
                        </div>

                        <div className="form-group mb-3">
                            <label className="form-label">Nouveau mot de passe</label>
                            <div className="input-icon-group">
                                <i className="bi bi-lock input-icon"></i>
                                <input 
                                    type={showNewPassword ? "text" : "password"} 
                                    className="form-control custom-input" 
                                    placeholder="••••••••" 
                                />
                                <i 
                                    className={`bi ${showNewPassword ? "bi-eye" : "bi-eye-slash"} toggle-eye-icon`} 
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    title={showNewPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                ></i>
                            </div>
                        </div>

                        <div className="form-group mb-4">
                            <label className="form-label">Confirmation du mot de passe</label>
                            <div className="input-icon-group">
                                <i className="bi bi-check2-circle input-icon"></i>
                                <input 
                                    type={showConfirmPassword ? "text" : "password"} 
                                    className="form-control custom-input" 
                                    placeholder="••••••••" 
                                />
                                <i 
                                    className={`bi ${showConfirmPassword ? "bi-eye" : "bi-eye-slash"} toggle-eye-icon`} 
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    title={showConfirmPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                ></i>
                            </div>
                        </div>

                        <button type="submit" className="btn-submit-custom">Changer le mot de passe</button>

                        <div className="form-footer-link">
                            <Link to="#">Choisir une autre méthode de récupération</Link>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}